import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPhoneStyle0 = gravityIconIndividualCss;

const GravityIconPhone = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'fea7b92521e0ca1742aa1259239cbb9b9e515b4e', color: this.color, size: this.size }, h("svg", { key: '65f5e60b9aa0ed162331d6c4f1f7ae8b32dfddb0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '350a433e59bdc5d503a6f5334ebc7af7fde1b785', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 3h-9a.5.5 0 0 0-.5.51v13.98a.499.499 0 0 0 .5.51h9a.5.5 0 0 0 .5-.51V3.51a.51.51 0 0 0-.5-.51Zm-1 12.5h-7v-11h7v11Z", fill: "currentColor" }))));
    }
};
GravityIconPhone.style = GravityIconPhoneStyle0;

export { GravityIconPhone as gravity_icon_phone };

//# sourceMappingURL=gravity-icon-phone.entry.js.map